"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var model_actions_creators_1 = require("./../../../store/model.actions.creators");
var styles = __importStar(require("./DiplomaRequest.module.css"));
var Header_1 = require("./parts/Header");
var ReleaseAuthorization_1 = require("./parts/ReleaseAuthorization");
var AcademicTranscript_1 = require("./parts/AcademicTranscript");
var AuthorizationForm_1 = require("./parts/AuthorizationForm");
var StudentSignature_1 = require("./parts/StudentSignature");
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data };
}
var mapDispatchToProps = {
    updateJonsCallback: model_actions_creators_1.updateJson
};
var FormComponent = (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent(props) {
        return _super.call(this, props) || this;
    }
    FormComponent.prototype.render = function () {
        var isPdf = false;
        if (window.isPdf) {
            isPdf = true;
        }
        var campus = this.props.json_data["campusState"] || "CA";
        return (react_1.default.createElement("div", { id: "diploma_request", className: styles.containerPosition + " " + styles.breakPage },
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
            react_1.default.createElement("div", { className: styles.pageSize },
                react_1.default.createElement(Header_1.Header, { stateSelected: campus }),
                react_1.default.createElement(ReleaseAuthorization_1.AsherReleaseAuthorization, null),
                react_1.default.createElement(AcademicTranscript_1.AsherAcademicTranscript, { stateSelected: campus, nextForm: this.props.nextForm }),
                react_1.default.createElement(AuthorizationForm_1.AsherAuthosizationForm, null),
                react_1.default.createElement(StudentSignature_1.AsherStudentSignature, { nextStudentForm: this.props.nextStudentForm })),
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
    };
    FormComponent.prototype.changeState = function (changeEvent) {
        this.setState({
            stateSelected: changeEvent.target.value
        });
    };
    return FormComponent;
}(react_1.Component));
exports.DiplomaRequestContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FormComponent);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlwbG9tYVJlcXVlc3RDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9EaXBsb21hUmVxdWVzdC9kaXBsb21hUmVxdWVzdENvbnRhaW5lci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QywyQ0FBbUM7QUFDbkMsa0ZBQWtFO0FBQ2xFLGtFQUFxRDtBQUVyRCx5Q0FBcUM7QUFDckMscUVBQXNFO0FBQ3RFLGlFQUFrRTtBQUNsRSwrREFBZ0U7QUFDaEUsNkRBQThEO0FBRTlELFNBQVMsZUFBZSxDQUFDLEVBQU87UUFBTixnQkFBSztJQUMzQixPQUFPLEVBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQyxTQUFTLEVBQUMsQ0FBQTtBQUN2QyxDQUFDO0FBRUQsSUFBTSxrQkFBa0IsR0FBRztJQUN2QixrQkFBa0IsRUFBRSxtQ0FBVTtDQUNqQyxDQUFBO0FBRUQ7SUFBNEIsaUNBQW1CO0lBQzNDLHVCQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFFaEIsQ0FBQztJQUVELDhCQUFNLEdBQU47UUFDSSxJQUFJLEtBQUssR0FBRyxLQUFLLENBQUE7UUFFakIsSUFBSSxNQUFNLENBQUMsS0FBSyxFQUFFO1lBQ2QsS0FBSyxHQUFHLElBQUksQ0FBQTtTQUNmO1FBQ0QsSUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksSUFBSSxDQUFBO1FBQzFELE9BQU8sQ0FDSCx1Q0FBSyxFQUFFLEVBQUMsaUJBQWlCLEVBQUMsU0FBUyxFQUFLLE1BQU0sQ0FBQyxpQkFBaUIsU0FBSSxNQUFNLENBQUMsU0FBVztZQUNqRixDQUFDLEtBQUssSUFBSSx1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsV0FBYSxHQUFRO1lBQ3BFLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsUUFBUTtnQkFLM0IsOEJBQUMsZUFBTSxJQUFDLGFBQWEsRUFBRSxNQUFNLEdBQUk7Z0JBQ2pDLDhCQUFDLGdEQUF5QixPQUFFO2dCQUM1Qiw4QkFBQyw0Q0FBdUIsSUFBQyxhQUFhLEVBQUUsTUFBTSxFQUFFLFFBQVEsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsR0FBRztnQkFDaEYsOEJBQUMsMENBQXNCLE9BQUc7Z0JBQzFCLDhCQUFDLHdDQUFxQixJQUFDLGVBQWUsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLGVBQWUsR0FBSSxDQUNwRTtZQUNMLENBQUMsS0FBSyxJQUFJLHVDQUFLLFNBQVMsRUFBRSxlQUFhLE1BQU0sQ0FBQyxXQUFhLEdBQVEsQ0FDbEUsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUVELG1DQUFXLEdBQVgsVUFBWSxXQUFXO1FBQ25CLElBQUksQ0FBQyxRQUFRLENBQUM7WUFDVixhQUFhLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQyxLQUFLO1NBQzFDLENBQUMsQ0FBQTtJQUNOLENBQUM7SUFDTCxvQkFBQztBQUFELENBQUMsQUFyQ0QsQ0FBNEIsaUJBQVMsR0FxQ3BDO0FBRVksUUFBQSx1QkFBdUIsR0FBRyxxQkFBTyxDQUFDLGVBQWUsRUFBRSxrQkFBa0IsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxDQUFBIn0=